










import { Component, Emit, Vue, Watch } from 'vue-property-decorator'
import { PhoneHelper } from '@/modules/login/helpers/PhoneHelper'

@Component({
  inheritAttrs: false,
})
export default class PhoneInput extends Vue {}
